export const ON_SELECTED_PRODUCT_CHANGE = "ON_SELECTED_PRODUCT_CHANGE";
export const ON_SELECTED_DATE_RANGE_CHANGE = "ON_SELECTED_DATE_RANGE_CHANGE";
export const ON_SELECTED_ZONE_CHANGE = "ON_SELECTED_ZONE_CHANGE";



// WEBPACK FOOTER //
// ./src/store/analytics/chart-filters/actions.js